export const AddCalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.6667 2.33333H12V1H10.6667V2.33333H5.33333V1H4V2.33333H3.33333C2.59333 2.33333 2.00667 2.93333 2.00667 3.66667L2 13C2 13.7333 2.59333 14.3333 3.33333 14.3333H12.6667C13.4 14.3333 14 13.7333 14 13V3.66667C14 2.93333 13.4 2.33333 12.6667 2.33333ZM12.6667 13H3.33333V5.66667H12.6667V13Z"
      fill="#E90C1B"
    />
    <path d="M8.5 8.5V7H7.5V8.5H6V9.5H7.5V11H8.5V9.5H10V8.5H8.5Z" fill="#E90C1B" />
  </svg>
)
